import { UNSAFE_noExposureExp } from '@atlassian/jira-feature-experiments';
import { EXPERIMENT_NAME_AA } from '../../common/utils/constants';

function getCohortValue(experimentName: string) {
	if (experimentName === EXPERIMENT_NAME_AA) {
		// eslint-disable-next-line jira/ff/unsafe-no-exposure
		const [expConfig] = UNSAFE_noExposureExp('jira_loss_aversion_standard_aa');
		return expConfig.get('cohort', 'not-enrolled');
	}

	// eslint-disable-next-line jira/ff/unsafe-no-exposure
	const [expConfig] = UNSAFE_noExposureExp('jira_loss_aversion_standard_ab');
	return expConfig.get('cohort', 'not-enrolled');
}

export function useExperimentEnrollment({
	experimentName,
	skip,
}: {
	experimentName: string;
	skip: boolean;
}) {
	if (skip) {
		return { cohort: 'not-enrolled', isEnrolled: false, isTreatment: false };
	}

	const cohort = getCohortValue(experimentName);

	const isTreatment = ['test', 'devtesting', 'devtesting_urgent'].includes(cohort);
	const isEnrolled = cohort !== 'not-enrolled';

	return { cohort, isEnrolled, isTreatment };
}
